import { NavLink } from "react-router-dom";
import { Home, Trophy, Gift, Bell, User } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useUnreadCount } from "@/hooks/useNotifications";

export function BottomNav() {
  const { t } = useTranslation();
  const unread = useUnreadCount();

  const items = [
    { to: "/", icon: Home, label: t("nav.home"), end: true },
    { to: "/matches", icon: Trophy, label: t("nav.matches") },
    { to: "/gift", icon: Gift, label: t("nav.gift") },
    { to: "/notifications", icon: Bell, label: t("nav.alerts"), badge: unread },
    { to: "/profile", icon: User, label: t("nav.profile") },
  ];

  return (
    <nav className="sticky bottom-0 z-40 surface-glass border-t border-white/[0.06] safe-bottom">
      <div className="mx-auto grid max-w-2xl grid-cols-5">
        {items.map(({ to, icon: Icon, label, end, badge }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "relative flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-medium transition-colors duration-180",
                isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon
                    className={cn("size-[22px] transition-colors", isActive && "text-primary")}
                    strokeWidth={isActive ? 2.25 : 1.75}
                  />
                  {badge && badge > 0 ? (
                    <span className="absolute -right-1.5 -top-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-destructive px-1 text-[9px] font-semibold text-destructive-foreground ring-2 ring-background">
                      {badge > 99 ? "99+" : badge}
                    </span>
                  ) : null}
                </div>
                <span className="tracking-tight">{label}</span>
                {isActive && (
                  <span className="absolute -top-px h-0.5 w-8 rounded-full bg-primary" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
